function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "#clip0"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.4344 1.0918H1.39375C0.736105 1.0918 0.161133 1.55129 0.161133 2.18218V13.892C0.161133 14.5265 0.736105 15.0918 1.39375 15.0918H13.4306C14.092 15.0918 14.5881 14.5229 14.5881 13.892V2.18218C14.5918 1.55129 14.092 1.0918 13.4344 1.0918ZM4.63335 12.7608H2.56646V6.52479H4.63335V12.7608ZM3.67131 5.57718H3.65628C2.99487 5.57718 2.56646 5.09945 2.56646 4.50138C2.56646 3.89236 3.00614 3.42558 3.68258 3.42558C4.35902 3.42558 4.7724 3.88872 4.78743 4.50138C4.78743 5.09945 4.35902 5.57718 3.67131 5.57718ZM12.1864 12.7613H10.1195V9.35155C10.1195 8.53468 9.81882 7.97672 9.07098 7.97672C8.49977 7.97672 8.16155 8.35234 8.01123 8.71701C7.95486 8.8483 7.93983 9.02699 7.93983 9.20933V12.7613H5.87293V6.5253H7.93983V7.39323C8.24047 6.9775 8.71021 6.37943 9.80379 6.37943C11.1604 6.37943 12.1864 7.24736 12.1864 9.11816V12.7613Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white",
  transform: "translate(0.00488281 0.807617)"
})));

function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.fb5fc427.svg";
export { ForwardRef as ReactComponent };